import React from "react";

class EpgTooltip extends React.Component {
  render() {
    return (
      <svg width="2.0625rem" height="5rem" viewBox="0 0 33 80" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <g id="Big-Screens" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="18.0" transform="translate(-702.000000, -49.000000)" fill="#000000" fill-rule="nonzero">
            <g id="Group" transform="translate(660.000000, 24.000000)">
              <g id="remote-control-(1)" transform="translate(42.000000, 25.000000)">
                <path
                  d="M30.0973172,2.76410631 C21.3986959,-0.92136877 11.4181906,-0.92136877 2.71956932,2.76410631 L4.55089914,7.08138158 C12.0867143,3.88581341 20.7303285,3.88581341 28.2661437,7.08138158 L30.0973172,2.76410631 Z"
                  id="Path"
                ></path>
                <path
                  d="M6.37972864,11.3963128 L8.20637035,15.7135881 C13.407197,13.5114292 19.4092207,13.5114292 24.6102037,15.7135881 L26.4368454,11.3963128 C20.0777444,8.6997152 12.7389859,8.6997152 6.37972864,11.3963128 Z"
                  id="Path"
                ></path>
                <circle id="Oval" cx="16.4083651" cy="63.4353647" r="2.34405216"></circle>
                <path
                  d="M0,63.4353647 C0,72.4819996 7.36173022,80 16.4083651,80 C25.4550001,80 32.8167303,72.4819996 32.8167303,63.4353647 L32.8167303,21.7409275 C25.9908504,19.4867307 20.7342353,18.7422597 16.4083651,18.7422597 C12.0962468,18.7422597 6.80431462,19.4939191 0,21.7409275 L0,63.4353647 Z M18.7524173,28.2745823 L23.4405216,28.2745823 L23.4405216,32.9626866 L18.7524173,32.9626866 L18.7524173,28.2745823 Z M18.7524173,37.6507909 L23.4405216,37.6507909 L23.4405216,42.3388952 L18.7524173,42.3388952 L18.7524173,37.6507909 Z M18.7524173,47.0269996 L23.4405216,47.0269996 L23.4405216,51.7151039 L18.7524173,51.7151039 L18.7524173,47.0269996 Z M9.37620865,28.2745823 L14.064313,28.2745823 L14.064313,32.9626866 L9.37620865,32.9626866 L9.37620865,28.2745823 Z M9.37620865,37.6507909 L14.064313,37.6507909 L14.064313,42.3388952 L9.37620865,42.3388952 L9.37620865,37.6507909 Z M9.37620865,47.0269996 L14.064313,47.0269996 L14.064313,51.7151039 L9.37620865,51.7151039 L9.37620865,47.0269996 Z M16.4083651,56.4032082 C20.2860525,56.4032082 23.4405216,59.5576774 23.4405216,63.4353647 C23.4405216,67.3130521 20.2860525,70.4675212 16.4083651,70.4675212 C12.5306778,70.4675212 9.37620865,67.3130521 9.37620865,63.4353647 C9.37620865,59.5576774 12.5306778,56.4032082 16.4083651,56.4032082 Z"
                  id="Shape"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  }
}

export default EpgTooltip;
